/**
 * @description 弹窗
 */
import React from 'react';
import { ALERT_TYPE } from '@/types';
import ReactDOM from 'react-dom/client';
import { delay } from 'lodash';
import cls from 'classnames';
import { addEventerHelper } from '@/utils/helper';
import style from './index.module.scss';
export let ToastCloneFn;
interface ToastProps {
  type: ALERT_TYPE;
  time?: number;
  render?: any;
  title?: string;
  confirm?: () => void;
  cancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  content?: any;
  closeCb?: () => void;
  onClose?: () => void;
  onCancel?: () => void;
  icon?: any;
  showCancel?: boolean;
  cancelBtn?: boolean;
  /** * 清除上次弹窗 */
  destroy?: boolean;
  // 点击蒙层关闭
  closeClickModal?: boolean;
}
const CreateDrawer = async (curProps) => {
  const { render: Render, ...props } = curProps;
  const { type, time = 1500, closeCb } = props;
  const ToastEl = React.lazy(() => import('./toast'));
  const Dialog = React.lazy(() => import('./dialog'));
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = ReactDOM.createRoot(container);
  // 新弹窗先把老弹窗关闭
  // ToastCloneFn?.();

  // 处理页面跳转关闭弹窗
  const handlePopFnc = () => {
    handleClose(true);
  };
  const destroy = addEventerHelper({
    event: 'popstate',
    element: window,
    listener: handlePopFnc,
  });
  const handleClose = (ifEvent = false) => {
    delay(() => {
      closeCb?.();
    }, 0);
    root.unmount();
    container.remove();
    if (!ifEvent) {
      destroy?.();
    }
  };
  ToastCloneFn = () => {
    root.unmount();
    container.remove();
  };
  const cx = () => {
    switch (type) {
      case ALERT_TYPE.TOAST:
        setTimeout(() => {
          handleClose();
        }, time);
        return (
          <ToastEl
            {...{
              ...props,
            }}
          />
        );
        break;
      case ALERT_TYPE.DIALOG:
        return (
          <Dialog
            {...{
              ...props,
              onClose: handleClose,
            }}
          />
        );
        break;
      case ALERT_TYPE.CONFIRM:
        return (
          <Dialog
            {...{
              ...props,
              onClose: handleClose,
              showCancel: false,
            }}
          />
        );
        break;
      case ALERT_TYPE.ANY:
        return (
          <Render
            {...{
              ...props,
              onClose: handleClose,
            }}
          />
        );
      default:
        break;
    }
    return <div />;
  };
  root.render(
    <div
      className={cls({
        [style.anyContainer]: type === ALERT_TYPE.ANY,
      })}
      onClick={() => {
        if (type === ALERT_TYPE.ANY) {
          ToastCloneFn();
        }
      }}
    >
      <React.Suspense>{cx()}</React.Suspense>
    </div>,
  );
};

export default CreateDrawer;

export const Toast = async (param: ToastProps) => {
  if (param.destroy) {
    // 清除以往的弹窗
    ToastCloneFn?.();
  }
  CreateDrawer(param);
};

export const showSeclectTicketType = (props) => {
  const render = React.lazy(() => import('../SeclectTicketType'));
  CreateDrawer({
    render,
    type: ALERT_TYPE.ANY,
    ...props,
  });
};
